var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"to-top d-i-b p-f"},[_c('a',{staticClass:"d-i-b",attrs:{"href":"javascript:;"},on:{"click":_vm.scrollTop}},[_c('img',{attrs:{"src":_vm.top,"alt":""}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30b3e1ae","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/smsgz/components/common/toTop/index.vue
// module id = Eg1R
// module chunks = 3